var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { getMarkerColor, getMarkerPrice } from "./utils";
import { Container, Text } from "./styled/listing-marker";
function ListingMarker(_a) {
    var _b = _a.offsetX, offsetX = _b === void 0 ? 0 : _b, _c = _a.offsetY, offsetY = _c === void 0 ? -5.5 : _c, price = _a.price, _d = _a.statusValue, statusValue = _d === void 0 ? "" : _d, color = _a.color, isHighlighted = _a.isHighlighted, isSelected = _a.isSelected, props = __rest(_a, ["offsetX", "offsetY", "price", "statusValue", "color", "isHighlighted", "isSelected"]);
    var markerColor = getMarkerColor({ statusValue: statusValue, isHighlighted: isHighlighted, color: color });
    return (React.createElement(Container, __assign({ offsetX: offsetX, offsetY: offsetX, color: markerColor, isSelected: isSelected }, props),
        isSelected && (React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 10" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.246.188a.75.75 0 01.066 1.058l-7.5 8.5a.75.75 0 01-1.092.034l-3.5-3.5a.75.75 0 111.06-1.06l2.936 2.935L11.188.254a.75.75 0 011.058-.066z" }))),
        React.createElement(Text, null, getMarkerPrice(price))));
}
// TODO: Using default props here as search marker relies on them.
// TODO: Codesmelly, fix later
// TODO: See src\components\search-map\SearchMarker.js:15,16
ListingMarker.defaultProps = {
    offsetX: 0,
    offsetY: -5.5
};
export default ListingMarker;
